import { Flex, Typography } from '@aloft/toolkit-sui';

import { useModuleContext } from '../../../modules/shared/moduleContext/useModuleContext.ts';
import { NavItemType } from './types.ts';
import { useIsSelectedNavItem } from './useIsSelectedNavItem.ts';

export const HeaderNavItem = ({ item, to }: { item: NavItemType; to: string }) => {
  const {
    navigation: { NavLink },
  } = useModuleContext();
  const isSelected = useIsSelectedNavItem(item.route);

  return (
    <Flex
      height="100%"
      alignItems="center"
      justifyContent="center"
      paddingLeft="0.5rem"
      paddingRight="0.5rem"
      position="relative"
      role="li"
    >
      <NavLink to={to}>
        <Flex alignItems="center" gap="6px">
          <Typography variant="h3" color={isSelected ? 'textPrimary' : 'textTertiary'}>
            {item.label}
          </Typography>
        </Flex>
      </NavLink>
      {isSelected && (
        <Flex
          position="absolute"
          bottom="0px"
          height=".125rem"
          width="100%"
          backgroundColor="textPrimary"
        />
      )}
    </Flex>
  );
};
